// extracted by mini-css-extract-plugin
module.exports = {"timeline":"EventsTab_timeline__2PWR_"};